export default {
  buttons: {
    title1: 'Decupare',
    title2: 'Închide',
  },
};
